import { connect } from 'react-redux'
import { get, flow } from 'lodash'
import { reduxForm } from 'redux-form'
import { PhoneSystemFormComponent } from './PhoneSystemForm'
import { SearchPhoneSystemDidNumbersQuery, GetUsagePlansQuery } from 'src/generated/graphql'

const formName = 'phoneSystem'
const stateToProps = ({ form }) => ({
  formData: get(form, `${formName}.values`, {}),
})

const dispatchToProps = {}

export interface IPhoneSystemFormContainerProps {
  productName: string
  onAfterSubmit: Function
  setHeadings?: Function
}

export interface IPhoneSystemFormData {
  lastEdited: string
  step: number
  productName?: string
  plan?: GetUsagePlansQuery['usagePlans'][0]
  ban?: string
  didNumbers?: SearchPhoneSystemDidNumbersQuery['searchPhoneSystemDIDNumbers']
}

export const PhoneSystemForm = flow<any, any, React.SFC<IPhoneSystemFormContainerProps>>(
  reduxForm<IPhoneSystemFormData>({
    form: formName,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    initialValues: {
      lastEdited: '',
      step: 1,
      didNumbers: [],
    },
  }),
  connect(stateToProps, dispatchToProps)
)(PhoneSystemFormComponent)



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemForm/PhoneSystemForm.container.ts